/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EquipmentTypeCatalogDto } from './EquipmentTypeCatalogDto';
import {
    EquipmentTypeCatalogDtoFromJSON,
    EquipmentTypeCatalogDtoFromJSONTyped,
    EquipmentTypeCatalogDtoToJSON,
} from './EquipmentTypeCatalogDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfEquipmentTypeCatalogDto
 */
export interface ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<EquipmentTypeCatalogDto>}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    value?: Array<EquipmentTypeCatalogDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    $type?: ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDeviceComponentDtoEquipmentTypeCatalogDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.EquipmentTypeCatalogDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum = typeof ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfEquipmentTypeCatalogDto interface.
 */
export function instanceOfODataPostProcessedResultsOfEquipmentTypeCatalogDto(value?: unknown): value is ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON(json: any): ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    return ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(EquipmentTypeCatalogDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfEquipmentTypeCatalogDtoToJSON(value?: ODataPostProcessedResultsOfEquipmentTypeCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(EquipmentTypeCatalogDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

